var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquidx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2471 22.4517L55.6653 64.4508H62.7797L31.3615 22.4517H24.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4513 0.478027C19.7176 0.478027 0.478027 19.7176 0.478027 43.4513C0.478027 67.1849 19.7176 86.4245 43.4513 86.4245C67.1849 86.4245 86.4245 67.1849 86.4245 43.4513C86.4245 19.7176 67.1849 0.478027 43.4513 0.478027ZM53.9864 67.8066L39.683 48.6816L21.9799 67.8066H17.4295L37.6499 45.9628L17.5565 19.0959H33.0432L46.2159 36.7092L62.519 19.0959H67.0694L48.249 39.429L69.473 67.8066H53.9864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidx);
export default __webpack_public_path__ + "static/media/squidx.94bde214edc869c6fcb7b3d632178d2c.svg";
export { ForwardRef as ReactComponent };